/* eslint-disable */
// import apisConfig from '../../config/apiDomainConfig'
import axios from 'axios';
import auth from '../../core/Auth';
import QuRequest from '../../core/QuRequest';

const baseRequest = new QuRequest();

const apiDomains = DOMAIN_API;

let api = {
  tagging: apiDomains.tagging.default,
  // qutoutiao: apiDomains.qupost.default,
  perm: apiDomains.perm.default,
  // audit:apiDomains.audit.default
};

axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded; charset=UTF-8';

let Api = {
  update: function(query) {
    if (query._qk && query._qk in apiDomains.qukan) {
      api.qukan = apiDomains.qukan[query._qk];
    }
    if (query._qtt && query._qtt in apiDomains.qutoutiao) {
      api.qutoutiao = apiDomains.qutoutiao[query._qtt];
    }
    if (query._audit && query._audit in apiDomains.audit) {
      api.audit = apiDomains.audit[query._audit];
    }
  },
};

function getProject(target) {
  let project = 'qukan';
  switch (target) {
    case 'qutoutiao':
      project = 'qupost';
      break;
    case 'perm':
      project = 'perm';
      break;
    case 'audit':
      project = 'audit';
      break;
  }
  return project;
}

function getUrl(path, target = 'qukan') {
  return baseRequest.getUrl({
    project: getProject(target),
    path: path,
  });
}

function request(reqData) {
  // console.log(reqData)
  let quRequest = new QuRequest();
  return quRequest.nativeSend(
    {
      url: reqData.url,
      type: reqData.method,
      timeout: reqData.timeout,
      headers: reqData.headers,
    },
    reqData.data,
  );
}

Api.install = function(Vue) {
  Vue.prototype.$httpFactory = function(oApi) {
    let reqs = {};
    for (let key in oApi) {
      (function(api) {
        reqs[key] = function(data = {}) {
          let quRequest = new QuRequest();
          return quRequest.send(
            {
              project: getProject(api.target),
              path: api.path,
              type: api.type,
            },
            data,
          );
        };
      })(oApi[key]);
    }
    return reqs;
  };

  Vue.prototype.$getApiUrl = getUrl;

  Vue.prototype.$getApiEnvConfig = () => {
    return apisConfig;
  };

  Vue.prototype.$blockRequest = function({
    $elem,
    req,
    pendingText = '操作中',
  }) {
    if (!$elem) {
      $elem = document.createElement('button');
    }
    if (!$elem || $elem._req_block) return;

    let isButton = $elem.nodeName.toLowerCase() === 'button';
    let oText = $elem.innerText;

    if (isButton) $elem.setAttribute('disabled', true);

    $elem.innerText = pendingText;
    $elem._req_block = true;

    return req.fin(() => {
      if (isButton) $elem.removeAttribute('disabled');
      $elem._req_block = false;
      $elem.innerText = oText;
    });
  };

  Vue.prototype.$getConfig = function(name, platform = 1) {
    let token = auth.getToken();

    return request({
      url: getUrl('/admin/config/getConfigList'),
      method: 'get',
      data: {
        platform: platform,
        name: name,
        token: token,
      },
      timeout: 5000,
    }).then(res => {
      let data = res.data;
      if (data.length && data.length > 0) {
        data = data[0][platform];
        return data;
      } else {
        throw new Error('配置不存在');
      }
    });
  };

  Vue.prototype.$checkContentSimilar = function({
    content,
    content_type = 1, // 1/2/3 去重的范围 文章/图片/视频 默认为1
    check_type = 0, // 文本为正文时，值为0， 文本为标题时，值为1. 默认为0
    similar_threshold = 0.8,
    currentId = '',
  }) {
    let token = auth.getToken();
    return request({
      url: getUrl('/admin/content/viewSimilarity'),
      method: 'post',
      data: {
        content,
        content_type,
        check_type,
        similar_threshold,
        token,
      },
      timeout: 10 * 1000,
    }).then(({ code, data, message }) => {
      let docIds = [];
      let docs = [];

      if (code != 0) {
        throw new Error('检查文章相似度失败： ' + message);
      }

      if (data.doc_url && data.doc_url.length) {
        data.doc_id.forEach((id, idx) => {
          if (!currentId || id != currentId) {
            docIds.push(id);
            docs.push(data.doc_url[idx]);
          }
        });
      }
      return {
        docs,
        docIds,
      };
    });
  };
};

export { Api, request, getUrl };



// WEBPACK FOOTER //
// ./src/common/js/Api.js